import Home from "../View/Home"
import Redirect from "../View/Redirect"
import NotFound from "../View/NotFound"
import ISL from "../View/Line/ISL"
import TWL from "../View/Line/TWL"
import TKL from "../View/Line/TKL"
import TCL from "../View/Line/TCL"
import KTL from "../View/Line/KTL"
import { ReactComponent as HomeSvg } from "../SVG/home.svg"


export const routes = [
    {
        path: '/',
        name: 'root',
        title: "Root",
        component: ISL,
        defaultpath: "/ISL"
    },
    // {
    //     path: '/',
    //     name: 'root',
    //     title: "Root",
    //     component: Redirect,
    //     defaultpath: "/home"
    // },
    // {
    //     path: '/home',
    //     name: 'home',
    //     title: "Home",
    //     component: Home
    // },
    {
        path: '/ISL',
        name: 'isl',
        title: "ISL",
        component: ISL
    },
    {
        path: '/TWL',
        name: 'twl',
        title: "TWL",
        component: TWL
    },
    // {
    //     path: '/TKL',
    //     name: 'tkl',
    //     title: "TKL",
    //     component: TKL
    // },
    // {
    //     path: '/TCL',
    //     name: 'tcl',
    //     title: "TCL",
    //     component: TCL
    // },
    // {
    //     path: '/KTL',
    //     name: 'ktl',
    //     title: "KTL",
    //     component: KTL
    // },
    
    {
        path: '*',
        name: 'NotFound',
        title: "NotFound",
        component: NotFound
    },

]

const HomeTitle = () => {
    return (
        <>
            <div style={{ display: 'inline-block' }}>
                <HomeSvg></HomeSvg>
            </div>
            Home
        </>
    );
}


export const pages = [
    // { path: '/', title: 'root' },
    { path: '/home', title: <HomeTitle></HomeTitle> },
    { path: '/ISL', title: 'ISL' },
    { path: '/TWL', title: 'TWL' },
    { path: '/TKL', title: 'TKL' },
    { path: '/TCL', title: 'TCL' },
    { path: '/KTL', title: 'KTL' },
    // { path: '*', title: 'NotFound' },
]